import src from "IMAGE";
export default { src, width: 2772, height: 1451, blurWidth: 0, blurHeight: 0};
